module.exports = __webpack_public_path__ + "static/media/image_33.7eedf974.png";